import "../polyfill"
import m from "mithril"

import { setErrorLoggerConfig } from "oj-error-logger"
setErrorLoggerConfig({
  projectId: 21,
  projectEnv: "default"
})

import "oj-event"
import { MithrilTsxComponent } from "mithril-tsx-component"
import { debounce, cleanString, isMobile } from "oj-utils"
import { HeaderMobile, HeaderDesktop } from "./editor/components/header"
import { Preview } from "./editor/components/preview"
import { ActionsMobile, ActionsDesktop } from "./editor/components/actions"
import * as State from "./editor/state"
import "css-reset-and-normalize-sass/scss/flavored-reset-and-normalize.scss"
import "./editor.scss"
import { animateClassNames, animateCreate } from "oj-mithril-utils"
import { Loader } from "../components/Loader"

class Dialogs {
  view(v) {
    const alert = State.getAlert()
    return <div className={cleanString("Dialogs", alert && "active", alert?.type && alert.type)} onclick={e => State.setDialog()}>
      {alert &&
        <div className={animateClassNames(v, "fade-from-top")}
          oncreate={v => animateCreate(v)}
          onclick={e => {
            e.stopPropagation()
          }}>
          <h1>{alert.title}</h1>
          {m.trust(alert.description)}
          {alert.actions && <div className="actions">
            {alert.actions.map(x => <button className={cleanString("outline", x.primary && "primary")} onclick={x.fn}>{x.title}</button>)}
          </div>}
        </div>
      }
    </div>
  }
}

class EditorMobile {
  view(v) {
    const zoom = State.getZoom()

    return [
      <HeaderMobile />,
      <Preview />,
      !zoom && <ActionsMobile />,
      <Dialogs />,
      State.isExporting() && <div className="to-cart-overlay"><Loader /></div>
    ]
  }
}

class EditorDesktop {
  view(v) {
    return [
      <ActionsDesktop />,
      <div>
        <HeaderDesktop />
        <Preview />
      </div>,
      <Dialogs />,
      State.isExporting() && <div className="to-cart-overlay"><Loader /></div>
    ]
  }
}

class Editor extends MithrilTsxComponent<{}> {
  async oninit(v) {
    await State.load()
  }

  view(v) {
    const mobile = isMobile()

    return <div className={cleanString("Editor", mobile ? "mobile" : "desktop")}>
      {mobile ? <EditorMobile /> : <EditorDesktop />}
    </div>
  }
}

const root = document.getElementById("root") as HTMLElement
m.mount(root, {
  view: v => <Editor />,
  oncreate: v => {
    root.parentElement.replaceChild(v.dom, root)
    window.on("resize", debounce(m.redraw, 100))
  }
})